import { useEffect } from 'react'

const SCROLL_DELTA_PX = 6
const TOP_THRESHOLD_PX = 8

export const useHideOnScrollDown = () => {
  useEffect(() => {
    let lastScrollY = window.scrollY
    let ticking = false

    const update = () => {
      const currentY = window.scrollY
      const delta = currentY - lastScrollY

      if (currentY <= TOP_THRESHOLD_PX) {
        document.body.dataset.scrolledDown = 'false'
      } else if (delta > SCROLL_DELTA_PX) {
        document.body.dataset.scrolledDown = 'true'
      } else if (delta < -SCROLL_DELTA_PX) {
        document.body.dataset.scrolledDown = 'false'
      }

      lastScrollY = currentY
      ticking = false
    }

    const onScroll = () => {
      if (!ticking) {
        window.requestAnimationFrame(update)
        ticking = true
      }
    }

    document.body.dataset.scrolledDown = 'false'
    window.addEventListener('scroll', onScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', onScroll)
      delete document.body.dataset.scrolledDown
    }
  }, [])
}
